import Contact from "../sections/Contact";

function Footer() {
  return (
    <footer>
      <div className="footer-center">
        <div className="title">Thank You for visiting :)</div>
        <Contact />
      </div>
    </footer>
  );
}

export default Footer;
